import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M12.472 0H3.539A3.536 3.536 0 00.003 3.536v8.933a3.536 3.536 0 003.536 3.536h8.933A3.536 3.536 0 0016 12.52V3.536A3.536 3.536 0 0012.472 0zm2.419 10.98l-3.112-3.558a2.114 2.114 0 00-3.082 0L6.561 9.863l-.7-.848a2.054 2.054 0 00-3.156 0l-1.586 1.913V3.536a2.427 2.427 0 012.42-2.42h8.933a2.427 2.427 0 012.419 2.42v7.444z"
        fill="#333"
      />
      <Path
        d="M4.283 5.77a1.489 1.489 0 100-2.978 1.489 1.489 0 000 2.977z"
        fill="#333"
      />
    </Svg>
  );
}

export default SvgComponent;
